import React from 'react';
import styles from './clientRestricted.module.scss';

const ClientRestrictedFeatureOverlay = () => (
  <div className={styles.restrictedOverlay}>
    <div className={styles.restrictedCard}>
      <div className={styles.restrictedBadge}>GOLD</div>
      <h2 className={styles.restrictedTitle}>Acceso Premium Requerido</h2>
      <p className={styles.restrictedDesc}>
        Esta funcionalidad está disponible solo para clientes con membresía
        <strong> Gold </strong> o <strong> Enterprise </strong>.
        Accede a análisis avanzados, reportes personalizados y soporte prioritario.
      </p>
      <a
        href="https://wa.me/593968652005?text=Hola%2C%20quiero%20actualizar%20mi%20plan%20a%20Gold%20o%20Enterprise"
        target="_blank"
        rel="noopener noreferrer"
        className={styles.restrictedCta}
      >
        Actualizar Membresía
      </a>
      <span className={styles.restrictedHint}>
        Contacta a nuestro equipo para más detalles
      </span>
    </div>
  </div>
);

export default ClientRestrictedFeatureOverlay;
